<template>
	<!-- 应用中心首页 -->
	<v-container fluid class="px-0" style="height: 100%">
		<div class="pb-3" style="width: 100%; height: 100%">
			<v-card class="ma-3" style="height: 100%" elevation="0">
				<v-card-title>
					<v-btn @click="$router.push('/uams/apps-apis')" color="blue" icon><v-icon>mdi-arrow-left</v-icon></v-btn>
					服务接口详情 <v-spacer />
					<v-btn @click="plan" class="elevation-0" color="orange" outlined>授权记录</v-btn>
				</v-card-title>
				<v-divider />
				<v-card-title class="pb-3">
					{{ entity.name || "" }}
					<v-chip class="ml-2" :color="entity.roleIs | dict('0:#ffb90018/1:#2abc3120')" :class="entity.roleIs | dict('0:orange--text/1:success--text')" small>
						{{ entity.roleIs | dict("0:未授权/1:已授权") }}
					</v-chip>
					<v-spacer />
					<v-btn @click="apply" class="elevation-0" color="success" outlined>授权申请</v-btn>
				</v-card-title>
				<v-card-text class="pb-2">
					<p class="mb-3">URL：{{ entity.path || "" }}</p>
					<p class="mb-3">Method：{{ entity.method || "" }}</p>
					<p class="mb-3">Content-Type：{{ entity.cttype || "" }}</p>
					<p class="mb-3">Accept：*/*</p>
					<p class="mb-3">Authorization: Bearer <a href="/wit-zswk-pui/docs/develop/应用接入/成为开发商.html#access-token" target="_blank" rel="noopener noreferrer">#access_token#</a></p>
					<p class="mb-0">Areacode: #areacode#</p>
				</v-card-text>

				<v-card-title>请求参数</v-card-title>
				<v-card-text>
					<v-data-table :headers="requestsHeader" :items="requestsDesserts" disable-pagination class="elevation-0" hide-default-footer></v-data-table>
					<v-divider />
				</v-card-text>

				<v-card-title>响应结果</v-card-title>
				<v-card-text>
					<v-data-table :headers="responseHeader" :items="responseDesserts" disable-pagination class="elevation-0" hide-default-footer></v-data-table>
					<v-divider />
				</v-card-text>
			</v-card>
		</div>
		<apps-apis-input ref="Mapis" />
		<apps-apis-plan ref="Mplan" />
	</v-container>
</template>
<script>
import Request from "@/commons/request";
import PageMixins from "@/compositions/mixins/pagination";
import appsApisInput from "./apps-apis-input";
import appsApisPlan from "./apps-apis-plan";
export default {
	mixins: [PageMixins],
	components: { appsApisInput, appsApisPlan },
	data: () => ({
		loading: true,
		requestsHeader: [
			{ text: "参数英文", value: "prop", sortable: false, width: 200 },
			{ text: "参数中文", value: "name", sortable: false, width: 200 },
			{ text: "参数类型", value: "type", sortable: false, width: 100 },
			// { text: "是否必填", value: "isFill", sortable: false, width: 90 },
			{ text: "参数说明", value: "note", sortable: false },
		],
		responseHeader: [
			{ text: "参数英文", value: "prop", sortable: false, width: 200 },
			{ text: "参数中文", value: "name", sortable: false, width: 200 },
			{ text: "参数类型", value: "type", sortable: false, width: 100 },
			{ text: "参数说明", value: "note", sortable: false },
		],
		entity: {},
		requestsDesserts: [],
		responseDesserts: [],
	}),
	activated() {
		this.view(this.$route.query.apiid);
	},
	methods: {
		view(apis) {
			Request.postForm("/app/apis/view", { acid: this.$vtk.storage.get("_wit_acis_users").acid, apis }).then((res) => {
				if (res.meta.success) {
					this.entity = res.data;
					if (this.entity.requests && this.entity.requests != "{}") {
						this.requestsDesserts = JSON.parse(this.entity.requests);
					} else {
						this.requestsDesserts = [];
					}
					if (this.entity.response && this.entity.requests != "{}") {
						this.responseDesserts = JSON.parse(this.entity.response);
					} else {
						this.responseDesserts = [];
					}

					this.method = this.entity.method;
					this.cttype = this.entity.cttype;
				}
			});
		},
		// 授权申请
		apply() {
			if (this.entity.roleIs == 1) {
				this.$vtk.message.toast("已经获取授权无法再次申请，如有变更请联系管理员", { color: " error " });
			} else {
				this.$refs.Mapis.edit(this.entity);
			}
		},
		// 申请流程记录
		plan() {
			this.$refs.Mplan.view(this.entity);
		},
	},
};
</script>
<style lang="scss" scoped>
::v-deep .v-tabs-slider-wrapper {
	z-index: -11;
	height: 100% !important;
	opacity: 0.1;
}
::v-deep .v-tabs-bar {
	height: 32px !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
	border-bottom: none !important;
}
::v-deep .v-data-table-header {
	background: #b5cff01f;
	border-radius: 12px;
}
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
	border-bottom: none !important;
}
::v-deep .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
	border-color: rgba(0, 0, 0, 0);
}
.serve_yhd {
	position: relative;
	&::before {
		content: "";
		display: inline-block;
		width: 128px;
		height: 128px;
		background: url(../../assets/img/yhd.png) no-repeat;
		background-size: contain;
		position: absolute;
		right: 12px;
		bottom: 0;
		opacity: 0.1;
	}
}
</style>
